import SVG from 'react-inlinesvg';
import { useRouter } from 'next/router';
import classnames from 'classnames/bind';

import { colorDetect } from '@autopass-web/domain';

import redirectHandler from '../../utils/redirect-handler';
import styles from './index.module.sass';
const cx = classnames.bind(styles);

const NavTop = ({
  back = true,
  onClick = undefined,
  onClose = undefined,
  title = '',
  background = undefined,
  theme = undefined,
  rightContent = undefined,
  event = undefined,
}) => {
  const router = useRouter();

  const navTopClass = cx({
    'nav-top': true,
    [theme]: true,
    revert: background ? colorDetect(background) === 'dark' : false,
  });

  const Leave = () => {
    if (onClose) {
      return (
        <div
          className={styles.leave}
          onClick={() => {
            if (event) event();
            onClose();
          }}
        >
          <SVG src="/assets/close.svg" />
        </div>
      );
    }

    return (
      <div
        className={styles.leave}
        onClick={() => {
          if (event) event();
          if (onClick) return onClick();
          redirectHandler.clear();
          router.back();
        }}
      >
        <SVG src="/assets/chevron-left.svg" />
      </div>
    );
  };

  return (
    <div className={navTopClass} style={background ? { background } : {}}>
      {back && <Leave />}
      <div className={styles.title}>{title}</div>
      <div className={styles['right-content']}>{rightContent}</div>
    </div>
  );
};

export default NavTop;
